import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { AuthService } from "./core/services/auth/auth.service";
import { Const } from "./core/data/models/const";
import { Router, NavigationEnd } from "@angular/router";
import { SessionService } from "./core/services/session.service";
import { LoginUserService } from "./core/services/login-user.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  public loggedIn: boolean;

  constructor(
    public auth: AuthService,
    public router: Router,
    private sessionService: SessionService,
  ) {
    this.router.events.subscribe(async (event) => {
      // 遷移後のイベント & ログイン画面以外だった場合に発火
      if (event instanceof NavigationEnd && this.router.url != "/login") {
        // Booleanを返すが、後続はないので何もしない
        await this.sessionService.checkSession();
      }
    });
  }

  ngOnInit() {
    this.subscription = this.auth.isAuthenticated().subscribe((result) => {
      this.loggedIn = result;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onClickLogout() {
    Const.release();
    this.auth.signOut();
  }
}
